















import ConfirmModal from '@/components/organisms/ConfirmModal.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: { ConfirmModal },
})
export default class AddressConfirmDialog extends Vue {
  @Prop({ required: true })
  address: string

  /**
   * 本ダイアログは配送事故防止の確認なので、お届け先住所を扱う画面では既定タイトルのまま使う。
   * プロフィール(注文者)住所を入力する画面では「お届け先」が事実と合わないため、差し替えられるようにしている。
   */
  @Prop({ default: 'お届け先住所の確認' })
  title: string
}
